import { getUrlQueryString } from '@shared/libs/utils'
import {createRouter, createWebHashHistory, createWebHistory, RouteRecordRaw, RouterHistory} from 'vue-router'

const routes: Array<RouteRecordRaw> = [
    {
        path: '/room/:id/enter',
        name: 'room_enter',
        component: () => import(/* webpackChunkName: "RoomEnter" */ '../views/RoomEnter.vue'),
        props: function (route) {
            return {
                id: parseInt(route.params.id as string),
            }
        },
        meta: {
            title: "进入直播间"
        }
    },
    {
        path: '/room/:id/watch',
        name: 'room_watch',
        component: () => import(/* webpackChunkName: "RoomWatcher" */ '../views/RoomWatcher.vue'),
        props: function (route) {
            return {
                id: parseInt(route.params.id as string),
            }
        },
        meta: {
            title: "直播间"
        }
    },
    {
        path: '/replay/:id/enter',
        name: 'room_enter_replay',
        component: () => import(/* webpackChunkName: "RoomEnter" */ '../views/RoomEnterReplay.vue'),
        props: function (route) {
            return {
                id: parseInt(route.params.id as string),
            }
        },
        meta: {
            title: "进入直播间"
        }
    },
    {
        path: '/replay/:id',
        name: 'room_replay',
        component: () => import(/* webpackChunkName: "RoomWatcher" */ '../views/RoomReplay.vue'),
        props: function (route) {
            return {
                id: parseInt(route.params.id as string),
            }
        },
        meta: {
            title: "直播间"
        }
    },
    {
        path: '/login/:id',
        name: 'login',
        component: () => import(/* webpackChunkName: "Login" */ '../views/Login.vue'),
        props: function (route) {
            return {
                id: parseInt(route.params.id as string),
            }
        },
        meta: {
            title: "EduSoho直播入口"
        }
    },
    {
        path: '/detection',
        name: 'detection',
        component: () => import(/* webpackChunkName: "Detection" */ '../views/Detection.vue'),
        meta: {
            title: "设备检测"
        }
    },
    {
        path: '/dev/login_student/:accessKey',
        name: 'dev_login_student',
        component: () => import(/* webpackChunkName: "DevLogin" */ '../views/DevLoginStudent.vue'),
        props: function (route) {
            return {
                accessKey: route.params.accessKey as string,
            }
        },
        meta: {
            title: "EduSoho直播测试入口 - H5 学生端"
        }
    },
    {
        path: '/404',
        name: 'error_404',
        component: () => import(/* webpackChunkName: "Error404" */ '../views/Error404.vue'),
        meta: {
            title: "404 - 页面不存在"
        },
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '/404',
    }
]

let history: RouterHistory;
const offline = getUrlQueryString("offline");
if (offline != null && offline === '1') {
    history = createWebHashHistory(process.env.BASE_URL);
} else {
    history = createWebHistory(process.env.BASE_URL);
}

const router = createRouter({
    history: history,
    routes
})

export default router
